import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AutoComplete, AutoCompleteModule } from 'primeng/autocomplete';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';

@Component({
  selector: 'app-offer-group-customer-dialog',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    DialogModule,
    AutoCompleteModule,
    ButtonModule,
  ],
  templateUrl: './offer-group-customer-dialog.component.html',
  styleUrl: './offer-group-customer-dialog.component.scss',
})
export class OfferGroupCustomerDialogComponent implements OnChanges {
  @Input() visible: boolean = false;
  @Input() loadingCustomers: boolean = false;
  @Input() customerMobile: string = '';
  @Input() filteredCustomersForOfferGroup: any[] = [];
  @Input() selectedCustomer: any = null;
  @Input() selectedOfferGroupId: number | null = null;

  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() customerMobileChange = new EventEmitter<string>();
  @Output() filterCustomers = new EventEmitter<any>();
  @Output() mobileSelect = new EventEmitter<any>();
  @Output() proceedWithCustomerRequested = new EventEmitter<void>();
  @Output() proceedWithoutCustomerRequested = new EventEmitter<void>();
  @Output() tabNavigation = new EventEmitter<KeyboardEvent>();

  @ViewChild('offerGroupMobileAutocomplete')
  offerGroupMobileAutocomplete!: AutoComplete;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['visible'] && this.visible) {
      setTimeout(() => {
        if (
          this.offerGroupMobileAutocomplete &&
          this.offerGroupMobileAutocomplete.el
        ) {
          const inputElement =
            this.offerGroupMobileAutocomplete.el.nativeElement.querySelector('input');
          if (inputElement) {
            inputElement.focus();
            inputElement.select();
          }
        }
      }, 150);
    }
  }

  onClose(): void {
    this.visible = false;
    this.visibleChange.emit(false);
  }

  onCustomerMobileChange(val: string): void {
    this.customerMobile = val;
    this.customerMobileChange.emit(val);
  }

  onFilterCustomers(event: any): void {
    this.filterCustomers.emit(event);
  }

  onOfferGroupMobileSelect(event: any): void {
    this.mobileSelect.emit(event);
  }

  proceedWithCustomer(): void {
    this.proceedWithCustomerRequested.emit();
  }

  proceedWithoutCustomer(): void {
    this.proceedWithoutCustomerRequested.emit();
  }

  handleOfferGroupDialogTabNavigation(event: KeyboardEvent): void {
    this.tabNavigation.emit(event);
  }
}
